import axios from 'axios';
import { CONTENT_TYPE } from '@/apis/constant';

export const checkCountryAndCurrency = ({ currency, country }) =>
  axios.get(`/billing/soldto/checkCountryAndCurrency?currency=${currency}&countryCode=${country}`);

export const updateSoldTo = (params) =>
  axios.post('/billing/z/soldto', params, {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON,
    },
  });

export const autocomplete = (params) => {
  const urlParams = new URLSearchParams(params).toString();
  return axios.get(`/buy/google/maps/autocomplete?${urlParams}`);
};

export const getAddrDetail = ({ placeId, language }) =>
  axios.get(`/buy/google/maps/place/details?place_id=${placeId}&language=${language}`);

export const getTtrTaxExemptLinkForBuyFlow = (params = {}) =>
  axios.post('/buy/TTRInfo', params, {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON,
    },
  });

export const getTtrTaxStatus = () =>
  axios.get('/buy/taxStatus', {
    headers: {
      'Content-Type': CONTENT_TYPE.JSON,
    },
  });

export const updateContact = (params) => axios.post('/payment/contact/update', params);

export const checkTaxNumber = (params) =>
  axios.post('/tax/validate', params, {
    headers: {
      'Content-Type': CONTENT_TYPE.FORM_DATA,
    },
  });
// PRICE INCREASE - checking api if soldto country changed
export const checkProMonthlyAndYearlyPrice = (countryCode, currency) =>
  axios.get('/price/increase/pro', { params: { countryCode, currency } });

export const getUseCase = () => axios.get('/billing/video_sdk/use_case');

/**
 *
 * @param {certificateId: string, customerNo: string} params
 * @returns
 */
export const getTaxStatusRequest = (params) => axios.get('/buy/ecm/status', { params });
